import { validateImgSlug } from '../img';

export interface IBuildShareVideoR2KeyArgs {
  slug: string;
  version: number;
}

export function buildShareVideoR2Key(args: IBuildShareVideoR2KeyArgs): string {
  if (!validateImgSlug(args.slug)) {
    throw new Error(`Invalid slug for share video R2 key: ${args.slug}`);
  }
  return `share/${args.slug}/coolmate-${args.slug}-v${args.version}.mp4`;
}
